;(function() {
  'use strict'

  Controller.$inject = ["$sce", "$timeout", "glUtils", "AudioPlayer", "mediaView"];
  angular.module('app.survey').component('surveySection', {
    controller: Controller,
    templateUrl: 'survey-section.html',
    bindings: {
      survey: '<',
      section: '<',
    },
  })

  function Controller($sce, $timeout, glUtils, AudioPlayer, mediaView) {
    var ctrl = this
    var hideTimer

    ctrl.$onInit = onInit
    ctrl.$onDestroy = onDestroy
    ctrl.expandImage = mediaView.showImage
    ctrl.isLong = isLong

    function onInit() {
      ctrl.title = ctrl.survey.injectValues(
        ctrl.section.titlePipes,
        ctrl.section.loopKey
      )

      if (
        ctrl.section.mediaType === ctrl.survey.SectionMediaTypes.VIDEO &&
        ctrl.section.youTubeVideoUrl
      ) {
        var videoUrl = glUtils.addParamsV2(ctrl.section.youTubeVideoUrl, {
          // controls: 0,
          rel: 0,
          modestbranding: 1,
        })
        ctrl.videoUrl = $sce.trustAsResourceUrl(videoUrl)
      }

      if (
        ctrl.section.mediaType === ctrl.survey.SectionMediaTypes.AUDIO &&
        ctrl.section.audioUrl
      ) {
        ctrl.audio = new AudioPlayer(ctrl.section.audioUrl)
      }

      if (
        ctrl.section.mediaType === ctrl.survey.SectionMediaTypes.IFRAME &&
        ctrl.section.iframeUrl
      ) {
        ctrl.iframeUrl = $sce.trustAsResourceUrl(ctrl.section.iframeUrl)
      }

      // delay timer
      if (!ctrl.section.delayComplete) {
        ctrl.survey.setDelay(ctrl.section.delay, function() {
          ctrl.section.delayComplete = true
        })
      }
      // hide timer
      if (!ctrl.section.hidden && ctrl.section.hide) {
        var ms = 1000 * ctrl.section.hide
        hideTimer = $timeout(function() {
          ctrl.section.hidden = true
        }, ms)
      }
      ctrl.section.timer.start()
    }

    function onDestroy() {
      if (ctrl.audio) ctrl.audio.destroy()
      ctrl.survey.setDelay(null)
      $timeout.cancel(hideTimer)
      ctrl.section.timer.stop()
    }

    function isLong() {
      return ctrl.section.title.length > 100
    }
  }
})()
